<div
  [@toggle]="state"
  (@toggle.start)="onAnimationEvent($event)"
  (@toggle.done)="onAnimationEvent($event)"
  [attr.class]="className"
>
  <div
    [class.with-close-button-and-title]="
      (notificationRef?.config)!.showClose && data.title && !data.message && !data.actionButtonLabel
    "
    class="notification-content"
  >
    <div class="icon" margin-right-small-x>
      <rt-notification-icon [notificationStyle]="currentNotificationStyle"></rt-notification-icon>
    </div>
    <div class="body">
      <ng-container portalHost></ng-container>
    </div>
    @if (data.topButtonLabel) {
      <div class="top-button-wrapper">
        <rt-button
          (click)="topButtonClick.emit()"
          variant="plain-ghost"
          size="small"
          class="notification-button"
          margin-right-small-xx
        >
          {{ data.topButtonLabel }}
        </rt-button>
      </div>
    }
    @if ((notificationRef?.config)!.showClose) {
      <div class="close-button-wrapper">
        <rt-icon-button
          (click)="dismiss($event)"
          class="notification-button"
          variant="plain-ghost"
          iconName="close"
          size="small"
          margin-left-small-xx
        ></rt-icon-button>
      </div>
    }
  </div>
  <div class="inside-border">
    @if (currentNotificationStyle === NotificationStyle.Timeout) {
      <div [style.width.%]="percentsOfProgress" class="progress-line"></div>
    }
  </div>
</div>
